const TournamentHistoryTypes = {
    GET_TOURNAMENT_HISTORY_START:'GET_TOURNAMENT_HISTORY_START',
    GET_TOURNAMENT_HISTORY_SUCCESS:'GET_TOURNAMENT_HISTORY_SUCCESS',
    GET_TOURNAMENT_HISTORY_FAILED:'GET_TOURNAMENT_HISTORY_FAILED',

}

export default TournamentHistoryTypes